import script from "./NewsPageStoryDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageStoryDropdown.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageStoryDropdown.vue?vue&type=style&index=0&id=08b1b56d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b1b56d"]])

export default __exports__